const HINTS: Record<string, string> = {
  UNSUPPORTED: 'O formato não é suportado. Use .xlsx, .xls ou CSV.',
  EMPTY: 'A planilha parece vazia. Verifique se há dados além do cabeçalho.',
  UNREADABLE: 'Não foi possível ler o arquivo. Ele pode estar corrompido.',
  NO_HEADERS: 'Não encontramos cabeçalhos. A primeira linha deve nomear as colunas.',
};

// Erro de AUTENTICAÇÃO não é erro do arquivo: ganha título e ação próprios
// (recarregar a sessão do Clerk), sem sugerir "tentar outro arquivo". Não há
// entrada de erro de organização aqui: o tenant é derivado automaticamente do
// usuário logado (ver apps/api/src/context.ts) e nunca falha.
const AUTH_TITLES: Record<string, string> = {
  NAO_AUTENTICADO: 'Sua sessão expirou',
};

export function UploadErrorState({
  msg,
  code,
  onRetry,
  onVoltar,
}: {
  msg: string;
  code?: string;
  onRetry: () => void;
  onVoltar: () => void;
}) {
  const authTitle = code ? AUTH_TITLES[code] : undefined;
  return (
    <div className="card px-8 py-12 text-center">
      <div
        className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full"
        style={{ background: 'var(--risk-soft)' }}
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
          <path d="M12 8v5m0 3h.01M10.3 3.9L2.4 18a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"
            stroke="var(--risk)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h2 className="text-lg font-semibold text-ink">
        {authTitle ?? 'Não conseguimos ler esse arquivo'}
      </h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-ink-3">{msg}</p>
      {!authTitle && code && HINTS[code] && (
        <p className="mx-auto mt-2 max-w-md text-sm text-ink-2">{HINTS[code]}</p>
      )}
      <div className="mt-6 flex justify-center gap-3">
        <button className="btn btn-ghost" onClick={onVoltar}>
          Voltar
        </button>
        {authTitle ? (
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Tentar novamente
          </button>
        ) : (
          <button className="btn btn-primary" onClick={onRetry}>
            Tentar outro arquivo
          </button>
        )}
      </div>
    </div>
  );
}
